<template>
  <v-container>
    <!--//@*/*
    //    *RPD  Nbirs test App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
    <!-- Question1 -->
    <!--  -->
    <!-- cols="12" -->
    <v-row id="s1q1" class="pt-0">
      <v-col class="d-flex justify-center">
        <v-card
          elevation="2"
          outlined
          shaped
          class="mt-1 pt-0 fixWidth"
          cols="12"
        >
          <v-card-title>Question 1</v-card-title>
          <v-card-subtitle class="pb-0"
            >Narratives must be read in their entirety prior to F/T a
            report.</v-card-subtitle
          >
          <v-card-subtitle class="pt-0 reference"></v-card-subtitle>
          <v-radio-group v-model="local_s1answers.s1q1" class="ml-8 mt-0">
            <v-radio label="True" value="s1q1-1"></v-radio>
            <v-radio label="False" value="s1q1-0"> </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question2 -->
    <v-row id="s1q2" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 2</v-card-title>
          <v-card-subtitle class="pb-0"
            >A single NOC can code to up to 8 different IBRS
            codes.</v-card-subtitle
          >
          <v-card-subtitle class="pt-0 reference"></v-card-subtitle>
          <v-radio-group v-model="local_s1answers.s1q2" class="ml-8 mt-0">
            <v-radio label="True" value="s1q2-1"></v-radio>
            <v-radio label="False" value="s1q2-0"> </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 3 -->
    <v-row id="s1q3" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 3</v-card-title>
          <v-card-subtitle class="pb-0"
            >A purple NOC code indicates…</v-card-subtitle
          >
          <v-card-subtitle class="pt-0 reference"></v-card-subtitle>
          <v-radio-group v-model="local_s1answers.s1q3" class="ml-8 mt-0">
            <v-radio label="Legacy value" value="s1q3-1"></v-radio>
            <v-radio
              label="A non-displayed NOC indicating you need to F1 to see the IBRS choices"
              value="s1q3-2"
            >
            </v-radio>
            <v-radio label="All of the above" value="s1q3-3"> </v-radio>
            <v-radio label="None of the above" value="s1q3-4"> </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 4 -->
    <v-row id="s1q4" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 4</v-card-title>
          <v-card-subtitle class="pb-0">
            "AC" on the offense tab in ARS means
            Attempted/Completed.</v-card-subtitle
          >
          <v-card-subtitle class="pt-0 reference"></v-card-subtitle>
          <v-radio-group v-model="local_s1answers.s1q4" class="ml-8 mt-0">
            <v-radio label="True" value="s1q4-1"></v-radio>
            <v-radio label="False" value="s1q4-0"> </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 5 -->
    <v-row id="s1q5" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 5</v-card-title>
          <v-card-subtitle class="pb-0"
            >"Used" on the Offense Tab in ARS can have more than one of the
            choices checked.</v-card-subtitle
          >
          <v-card-subtitle class="pt-0 reference"></v-card-subtitle>
          <v-radio-group v-model="local_s1answers.s1q5" class="ml-8 mt-0">
            <v-radio label="True" value="s1q5-1"></v-radio>
            <v-radio label="False" value="s1q5-0"> </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 6 -->
    <v-row id="s1q6" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 6</v-card-title>
          <v-card-subtitle class="pb-0"
            >The choices on the "Used" column indicate whether a computer,
            alcohol, or none were used during the commission of the
            crime.</v-card-subtitle
          >
          <v-card-subtitle class="pt-0 reference"></v-card-subtitle>
          <v-radio-group v-model="local_s1answers.s1q6" class="ml-8 mt-0">
            <v-radio label="True" value="s1q6-1"></v-radio>
            <v-radio label="False" value="s1q6-0"> </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 7 -->
    <v-row id="s1q7" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 7</v-card-title>
          <v-card-subtitle class="pb-0"
            >The "Bias Motivation" Column is where hate crime information is
            logged.</v-card-subtitle
          >
          <v-card-subtitle class="pt-0 reference"></v-card-subtitle>
          <v-radio-group v-model="local_s1answers.s1q7" class="ml-8 mt-0">
            <v-radio label="True" value="s1q7-1"></v-radio>
            <v-radio label="False" value="s1q7-0"> </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 8 -->
    <v-row id="s1q8" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 8</v-card-title>
          <v-card-subtitle class="pb-0"
            >A 7-11 clerk is robbed, the location type is "Convenience
            Store".</v-card-subtitle
          >
          <v-card-subtitle class="pt-0 reference"></v-card-subtitle>
          <v-radio-group v-model="local_s1answers.s1q8" class="ml-8 mt-0">
            <v-radio label="True" value="s1q8-1"></v-radio>
            <v-radio label="False" value="s1q8-0"> </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 9 -->
    <v-row id="s1q9" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 9</v-card-title>
          <v-card-subtitle class="pb-0"
            >A patron pumping gas at a 7-11 has her purse taken from her car.
            The location type is:</v-card-subtitle
          >
          <v-radio-group v-model="local_s1answers.s1q9" class="ml-8 mt-0">
            <v-radio label="Convenience Store" value="s1q9-1"></v-radio>
            <v-radio label="Service, Gas Station" value="s1q9-2"> </v-radio>
            <v-radio
              label="Highway, Road, Alley, Street, Sidewalk"
              value="s1q9-3"
            >
            </v-radio>
            <v-radio label="Specialty Store" value="s1q9-4"> </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 10 -->
    <v-row id="s1q10" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 10</v-card-title>
          <v-card-subtitle class="pb-0"
            >Column "# Pr" on the Offense tab is used when:</v-card-subtitle
          >
          <v-card-subtitle class="mb-1">
            <p class="pl-3 text-sm-caption mb-0">
              (a) A storage facility has several units broken into.
            </p>
            <p class="pl-3 text-sm-caption mb-0">
              (b) Several rooms in a hotel are burglarized.
            </p>
            <p class="pl-3 text-sm-caption mb-1">
              (b) Several Apartments in the same building are burglarized.
            </p>
          </v-card-subtitle>
          <v-radio-group v-model="local_s1answers.s1q10" class="ml-8 mt-0">
            <v-radio label="All of the above" value="s1q10-1"></v-radio>
            <v-radio label="None of the above" value="s1q10-2"> </v-radio>
            <v-radio label="B & C" value="s1q10-3"> </v-radio>
            <v-radio label="A & B" value="s1q10-4"> </v-radio>
            <v-radio label="A & C" value="s1q10-5"> </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 11 -->
    <v-row id="s1q11" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 11</v-card-title>
          <v-card-subtitle class="pb-0"
            >Column "ME" on the Offense tab indicates whether or not force was
            used.</v-card-subtitle
          >
          <v-radio-group v-model="local_s1answers.s1q11" class="ml-8 mt-0">
            <v-radio label="True" value="s1q11-1"></v-radio>
            <v-radio label="False" value="s1q11-0"> </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 12 -->
    <v-row id="s1q12" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 12</v-card-title>
          <v-card-subtitle class="pb-0"
            >The options on column "Crim Act" on the Offense tab, change
            depending on whether or not the offense is a crime against persons
            or a crime against property.</v-card-subtitle
          >
          <v-radio-group v-model="local_s1answers.s1q12" class="ml-8 mt-0">
            <v-radio label="True" value="s1q12-1"></v-radio>
            <v-radio label="False" value="s1q12-0"> </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 13 -->
    <v-row id="s1q13" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 13</v-card-title>
          <v-card-subtitle class="pb-0"
            >Column "Weapon Type" indicates what type of weapon was used during
            the commission of the crime. More than one weapon type can be
            chosen.</v-card-subtitle
          >
          <v-radio-group v-model="local_s1answers.s1q13" class="ml-8 mt-0">
            <v-radio label="True" value="s1q13-1"></v-radio>
            <v-radio label="False" value="s1q13-0"> </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- NO QUESTION 14 IN THIS TEST -->

    <!-- Question 15 -->
    <v-row id="s1q15" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 15</v-card-title>
          <v-card-subtitle class="pb-0"
            >Which of the following are examples of cargo
            theft:</v-card-subtitle
          >
          <v-radio-group v-model="local_s1answers.s1q15" class="ml-8 mt-0">
            <v-radio
              label="A UPS driver has his truck stolen during a delivery."
              value="s1q15-1"
            ></v-radio>
            <v-radio
              label="A Moving van carrying a family's possessions from NE to CA is broken into in CO."
              value="s1q15-2"
            >
            </v-radio>
            <v-radio
              label="An OTR trucker enroute for the manufacturer in TN the distributor in KS has his load stolen in MO."
              value="s1q15-3"
            ></v-radio>
            <v-radio
              label="Trucker in the 3rd choice reaches the Distributor, the load is stolen from the Distributor's bay."
              value="s1q15-4"
            ></v-radio>
            <v-radio label="All of the above" value="s1q13-5"></v-radio>
            <v-radio label="None of the above" value="s1q13-6"></v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 16 -->
    <v-row id="s1q16" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 16</v-card-title>
          <v-card-subtitle class="pb-0"
            >Every crime must have the DV column(s) completed.</v-card-subtitle
          >
          <v-card-subtitle class="pt-0 reference"></v-card-subtitle>
          <v-radio-group v-model="local_s1answers.s1q16" class="ml-8 mt-0">
            <v-radio label="True" value="s1q16-1"></v-radio>
            <v-radio label="False" value="s1q16-0"> </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 17 -->
    <v-row id="s1q17" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 17</v-card-title>
          <v-card-subtitle class="pb-0"
            >Every Crime Report, whether against a person, property or Society
            must have a suspect (or arrested person) and victim.
          </v-card-subtitle>
          <v-radio-group v-model="local_s1answers.s1q17" class="ml-8 mt-0">
            <v-radio label="True" value="s1q17-1"></v-radio>
            <v-radio label="False" value="s1q17-0"> </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 18-->
    <v-row id="s1q18" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 18</v-card-title>
          <v-card-subtitle class="pb-0"
            >What should the incident type be in this scenario: A woman is
            playing the slots in Circus Circus. Her ex-husband comes and tries
            to grab her purse which is on the ground next to her. The woman sees
            him, and tries to stop him. He tells her that he has a gun on him
            and if she makes a scene he will shoot her, and demands she come
            with him.</v-card-subtitle
          >
          <v-radio-group v-model="local_s1answers.s1q18" class="ml-8 mt-0">
            <v-radio label="Assault-Aggravated" value="s1q18-1"></v-radio>
            <v-radio label="Kidnap" value="s1q18-2"> </v-radio>
            <v-radio label="Robbery" value="s1q18-3"> </v-radio>
            <v-radio label="Theft - Building" value="s1q18-4"></v-radio>
            <v-radio label="Any of the above" value="s1q18-5"> </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 19 -->
    <v-row id="s1q19" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 19</v-card-title>
          <v-card-subtitle class="pb-0"
            >Bank of America is robbed. What is the minimum number of victims
            that has to be listed.</v-card-subtitle
          >
          <v-radio-group v-model="local_s1answers.s1q19" class="ml-8 mt-0">
            <v-radio label="One, the teller" value="s1q19-1"></v-radio>
            <v-radio label="One, the bank" value="s1q19-2"> </v-radio>
            <v-radio label="Two, the teller and the bank." value="s1q19-3">
            </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 20 DELETED  -->
    <!-- <v-row id="s1q20" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 17</v-card-title>
          <v-card-subtitle class="pb-0"
            >During an argument between an ex-boyfriend (John) and ex-girlfriend
            (Jane). John pushes Jane and Jane grabs John. John calls the police.
            There are no visible injuries and no independent witnesses, but both
            insist they are in pain. The officer takes the report as a mutual
            battery. Answer the following questions:
          </v-card-subtitle>

          <v-container id="q20_form" fluid class="q20_label">
            <v-text-field
              v-model="local_q20Form.weapon"
              label="What is the weapon type?"
              required
              max-length="500"
              placeholder=""
            >
            </v-text-field>
            <v-text-field
              v-model="local_q20Form.domViolence"
              label="Is this a domestic violence? "
              required
              max-length="500"
              placeholder=""
            >
            </v-text-field>
            <v-text-field
              v-model="local_q20Form.suspects"
              label="How many suspects are there in this situation?"
              required
              max-length="500"
              placeholder=""
            >
            </v-text-field>
            <v-text-field
              v-model="local_q20Form.victims"
              label="How many victims are there in this situation?"
              required
              max-length="500"
              placeholder=""
            >
            </v-text-field>
            <v-text-field
              v-model="local_q20Form.attack"
              label="What is the means of attack?"
              required
              max-length="500"
              placeholder=""
            >
            </v-text-field>
            <v-text-field
              v-model="local_q20Form.injury"
              label="What is the extent of injury?"
              required
              max-length="500"
              placeholder=""
            >
            </v-text-field>
            <v-text-field
              v-model="local_q20Form.relationship"
              label="What is the relationship between John and Jane? "
              required
              max-length="500"
              placeholder=""
            >
            </v-text-field>
          </v-container>
        </v-card>
      </v-col>
    </v-row> -->

    <!-- Question 21  -->
    <v-row id="s1q21" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 21</v-card-title>
          <v-card-subtitle class="pb-0"
            >John (45 years old) and his children Dora (16 yoa) and Paul (15
            yoa) go to visit John’s father Ted (75 yoa). Once at the house Paul
            goes next door to a friend’s house and Dora stays with her father
            and grandfather. During the visit John gets into a physical fight
            with Ted. Ted is knocked down and suffers fractures on his wrist and
            hip. Dora tries to intervene and John knocks her down. Dora calls
            the police. John is arrested. Ted is transported to Renown by Remsa
            and given information on how to obtain a TPO. Which of the below is
            correct?</v-card-subtitle
          >
          <v-radio-group v-model="local_s1answers.s1q21" class="ml-8 mt-0">
            <v-radio
              label="The crime is domestic violence. There was 1 child present. Medical attention is required and a Domestic Violence card is given.  John is CH to Ted and Dora is CH to John."
              value="s1q21-1"
            ></v-radio>
            <v-radio
              label="The crime is domestic violence. There are 2 children present. Medical attention is required and a Domestic Violence card is given. John is PA to Ted and Dora is GC to Ted."
              value="s1q21-2"
            >
            </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 22  -->
    <v-row id="s1q22" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 22</v-card-title>
          <v-card-subtitle class="pb-0"
            >Larry gets on a computer dating site and meets Laura. They
            correspond on the site for a while then give each other their
            personal phone numbers, however they never meet in person. During
            these conversations Laura convinces Larry to send photos of himself
            masturbating. Larry sends the photos. The next day Laura contacts
            Larry telling him he has to send her $5000 or she will send the
            photos to all of his contacts, she provides the names and correct
            phone numbers of everyone on his contact list as proof. Larry
            doesn't send the money but instead files a police report. Which of
            the below are true.</v-card-subtitle
          >
          <v-card-subtitle class="mb-1">
            <p class="pl-3 text-sm-caption mb-0">
              (a) The Offense is Extortion.
            </p>
            <p class="pl-3 text-sm-caption mb-0">
              (b) The offense is completed.
            </p>
            <p class="pl-3 text-sm-caption mb-0">
              (c) The offense is attempted.
            </p>
            <p class="pl-3 text-sm-caption mb-0">
              (d) The 'Use' column on the Offense is 'N'.
            </p>
            <p class="pl-3 text-sm-caption mb-0">
              (e) This is a domestic violence.
            </p>
            <p class="pl-3 text-sm-caption mb-0">
              (f) Property is required to be listed.
            </p>
          </v-card-subtitle>
          <v-radio-group v-model="local_s1answers.s1q22" class="ml-8 mt-0">
            <v-radio label="A & B" value="s1q22-1"></v-radio>
            <v-radio label="B & D" value="s1q22-2"></v-radio>
            <v-radio label="A & C" value="s1q22-3"> </v-radio>
            <v-radio label="D & F" value="s1q22-4"></v-radio>
            <v-radio label="C & E" value="s1q22-5"></v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 23  -->
    <v-row id="s1q23" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 23</v-card-title>
          <v-card-subtitle class="pb-0"
            >Returning home from a night at the casino Molly discovers her cell
            phone and wallet have been taken from her purse. She knows she had
            both while at the casino because she used both at the casino. She
            states while she was gambling she always placed her purse on the
            floor next to her chair. She reports her Driver's license, $240
            cash, and her debit card were in her wallet. She immediately
            contacted the bank and canceled the debit card, no fraudulent
            activity was conducted with the card. Which of the below are
            correct?</v-card-subtitle
          >
          <v-card-subtitle class="mb-1">
            <p class="pl-3 text-sm-caption mb-0">
              (a) The NOC must pull an IBRS code for shoplifting.
            </p>
            <p class="pl-3 text-sm-caption mb-0">
              (b) The NOC must pull an IBRS code for Theft from building.
            </p>
            <p class="pl-3 text-sm-caption mb-0">
              (c) The property tab can be “Y - Other” with a description of what
              was stolen.
            </p>
            <p class="pl-3 text-sm-caption mb-0">
              (d) There must be 4 items of property stolen all with the correct
              Category and Article type listed along with valid property values.
            </p>
          </v-card-subtitle>
          <v-radio-group v-model="local_s1answers.s1q23" class="ml-8 mt-0">
            <v-radio label="A & C" value="s1q23-1"></v-radio>
            <v-radio label="B & C" value="s1q23-2"> </v-radio>
            <v-radio label="B & D" value="s1q23-3"></v-radio>
            <v-radio label="C & D" value="s1q23-4"> </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 24  -->
    <v-row id="s1q24" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 24</v-card-title>
          <v-card-subtitle class="pb-0"
            >A Vehicle was broken into and a laptop was stolen. There is no
            information on the suspect. Which of the below is
            correct?</v-card-subtitle
          >
          <v-card-subtitle class="mb-1">
            <p class="pl-3 text-sm-caption mb-0">
              (a) Suspect is listed as ;UNK or ;Unknown
            </p>
            <p class="pl-3 text-sm-caption mb-0">
              (b) Suspect is listed as UNK or Unknown
            </p>
            <p class="pl-3 text-sm-caption mb-0">
              (c) The IBRS code must pull to a Veh - Burg
            </p>
            <p class="pl-3 text-sm-caption mb-0">
              (d) The IBRS code must pull to Burg 1st
            </p>
          </v-card-subtitle>
          <v-radio-group v-model="local_s1answers.s1q24" class="ml-8 mt-0">
            <v-radio label="A & C" value="s1q24-1"></v-radio>
            <v-radio label="B & C" value="s1q24-2"> </v-radio>
            <v-radio label="B & D" value="s1q24-3"></v-radio>
            <v-radio label="C & D" value="s1q24-4"> </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 25 -->
    <v-row id="s1q25" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 25</v-card-title>
          <v-card-subtitle class="pb-0"
            >An RPD arrest on a RPD warrant must always have a new case number
            UNLESS it is an original charge warrant.</v-card-subtitle
          >
          <v-radio-group v-model="local_s1answers.s1q25" class="ml-8 mt-0">
            <v-radio label="True" value="s1q25-1"></v-radio>
            <v-radio label="False" value="s1q25-0"> </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 26 -->
    <v-row id="s1q26" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 26</v-card-title>
          <v-card-subtitle class="pb-0"
            >An officer is injured by a suspect during an arrest. The Officer's
            involvement in that case is...</v-card-subtitle
          >
          <v-radio-group v-model="local_s1answers.s1q26" class="ml-8 mt-0">
            <v-radio
              label="LEP and 'I' for individual type"
              value="s1q26-1"
            ></v-radio>
            <v-radio label="VIC and 'L' for individual type" value="s1q26-2">
            </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 27  -->
    <v-row id="s1q27" class="pt-0">
      <v-col class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 27</v-card-title>
          <v-card-subtitle class="pb-0"
            >A vehicle is broken into. The contents of the glove box and center
            console have been rifled through and are strewn around in the car.
            Which of the below is correct?</v-card-subtitle
          >
          <v-radio-group v-model="local_s1answers.s1q27" class="ml-8 mt-0">
            <v-radio
              label="The offense should be coded as completed with no property taken"
              value="s1q27-1"
            ></v-radio>
            <v-radio
              label="The offense should be coded as attempted with no property taken"
              value="s1q27-2"
            >
            </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 28  -->
    <v-row id="s1q28" class="pt-0">
      <v-col class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 28</v-card-title>
          <v-card-subtitle class="pb-0"
            >A detective posing as a 14 year old girl on "Backdoor" connects
            with a john and agrees to perform various sex acts for $350. The
            john arrives at the agreed upon location and is arrested for
            trafficking. Which of the below is correct?</v-card-subtitle
          >
          <v-radio-group v-model="local_s1answers.s1q28" class="ml-8 mt-0">
            <v-radio
              label="The offense is listed as completed and the victim is listed as unknown."
              value="s1q28-1"
            ></v-radio>
            <v-radio
              label="The offense is listed as attempted and the victim is listed as an unknown name 14 year old female."
              value="s1q28-2"
            >
            </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 29  -->
    <v-row id="s1q29" class="pt-0">
      <v-col class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 29</v-card-title>
          <v-card-subtitle class="pb-0"
            >All reports must be validated.</v-card-subtitle
          >
          <v-radio-group v-model="local_s1answers.s1q29" class="ml-8 mt-0">
            <v-radio label="True" value="s1q29-1"></v-radio>
            <v-radio label="False" value="s1q29-0"> </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 30  -->
    <v-row id="s1q30" class="pt-0">
      <v-col class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 30</v-card-title>
          <v-card-subtitle class="pb-0"
            >A report that is not NIBRS reportable can become NIBRS reportable
            depending on the investigation.</v-card-subtitle
          >
          <v-radio-group v-model="local_s1answers.s1q30" class="ml-8 mt-0">
            <v-radio label="True" value="s1q30-1"></v-radio>
            <v-radio label="False" value="s1q30-0"> </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 31  -->
    <v-row id="s1q31" class="pt-0">
      <v-col class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 31</v-card-title>
          <v-card-subtitle class="pb-0"
            >It is okay to submit a report with a purple NOC
            code.</v-card-subtitle
          >
          <v-radio-group v-model="local_s1answers.s1q31" class="ml-8 mt-0">
            <v-radio label="True" value="s1q31-1"></v-radio>
            <v-radio label="False" value="s1q31-2"> </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 32  -->
    <v-row id="s1q32" class="pt-0">
      <v-col class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 32</v-card-title>
          <v-card-subtitle class="pb-0"
            >When a purple NOC populates you are required to:</v-card-subtitle
          >
          <v-radio-group v-model="local_s1answers.s1q32" class="ml-8 mt-0">
            <v-radio
              label="Do nothing, sometimes we just have these."
              value="s1q32-1"
            ></v-radio>
            <v-radio
              label="F1 the NOC code to see if the NOC is a legacy value or if there is a “dot NOC” that should be used instead."
              value="s1q32-2"
            >
            </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 33  -->
    <v-row id="s1q33" class="pt-0">
      <v-col class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 33</v-card-title>
          <v-card-subtitle class="pb-0"
            >A report is taken where the victim was robbed, threatened with a
            gun, however the victim never sees a gun. The means of attack
            is:</v-card-subtitle
          >
          <v-radio-group v-model="local_s1answers.s1q33" class="ml-8 mt-0">
            <v-radio label="Threats" value="s1q33-1"></v-radio>
            <v-radio label="Firearm" value="s1q33-2"> </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- to get the section 2 link in the right place -->
    <!-- <div >
          <div class="mt-6"></div>
        </div> -->
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  #home-container {
    width: 100%;
    max-width: 768px;
    height: auto;
    padding-top: 65px;
    margin: auto;
  }

  #home-container .v-card__subtitle {
    color: #5c5c5c;
  }

  #home-container a {
    color: #1565c0;
  }

  #home-container a.temp-2-nav {
    color: aliceblue;
  }
  .fixWidth {
    width: 100%;
  }

  .rad1 {
    background-color: white;
    height: 250px;
    width: 80%;
  }

  .alice {
    color: aliceblue;
  }

  .v-card__subtitle.reference {
    color: blue;
  }

  .noWordWrap {
    white-space: nowrap;
  }

  .q17_label .v-input .v-label {
    font-size: 13px !important;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  #home-container {
    width: 100%;
    max-width: 768px;
  }
}

/* ipad landscape */
@media (min-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
  .fixWidth {
    width: 80%;
  }
}

/* 1025 media q */
@media (min-width: 1025px) {
  #home-container {
    width: 100%;
    max-width: 768px;
  }

  .fixWidth {
    width: 80%;
  }
}

/* 2048 media q */
@media (min-width: 2048px) {
  #home-container {
    width: 100%;
    max-width: 768px;
  }
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "section1",
  mixins: [bus_common],
  props: ["session", "sanwers1"],
  data() {
    return {
      bFirstUpdate: false,
      local_s1answers: {},

      bReadyToUpdate: false,
    };
  },
  watch: {
    local_s1answers: {
      deep: true,
      handler() {
        this.update_answers();
      },
    },
  },
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    update_answers() {
      if (this.bReadyToUpdate) {
        this.$emit("update_answers", this.local_s1answers);
      }
    },
    init() {
      this.local_s1answers = this.mno(this.sanwers1);
      this.$nextTick(() => {
        this.bReadyToUpdate = true;
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
